/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_Ahead_TaskInputs */

const en_editor_prep_ahead_task = /** @type {(inputs: Editor_Prep_Ahead_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const de_editor_prep_ahead_task = /** @type {(inputs: Editor_Prep_Ahead_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabe`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Editor_Prep_Ahead_TaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead_task = /** @type {((inputs?: Editor_Prep_Ahead_TaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_Ahead_TaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead_task(inputs)
	return en_editor_prep_ahead_task(inputs)
});